'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createUnauthorizedApiResponseHandler;

var _isUnauthorizedResponse = require('../isUnauthorizedResponse');

var _isUnauthorizedResponse2 = _interopRequireDefault(_isUnauthorizedResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Common pattern for handling api request failures
function createUnauthorizedApiResponseHandler(apiFunc) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (unauthorizedHandler) {
    return apiFunc.apply(undefined, args).catch(function (apiError) {
      if ((0, _isUnauthorizedResponse2.default)(apiError)) {
        if (unauthorizedHandler) {
          return unauthorizedHandler(apiError);
        }
      }

      throw apiError;
    });
  };
}
//# sourceMappingURL=createUnauthorizedApiResponseHandler.js.map